// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2ei8V","top":"styles_top__3Jn3m","left":"styles_left__1f1Cm","description":"styles_description__3SQld"};